import React from 'react';
import { Receipt, CalendarOff, Bell, Settings, ClipboardList } from 'lucide-react';
import { EaserExpenses } from './EaserExpenses';
import { EaserLeaves } from './EaserLeaves';
import { EaserNotifications } from './EaserNotifications';
import { EaserSettings } from './EaserSettings';
import { EaserRequests } from './EaserRequests';

export const GRH_SUBTABS = [
  { id: 'frais', label: 'Notes de frais', icon: Receipt },
  { id: 'conges', label: 'Congés', icon: CalendarOff },
  { id: 'demandes', label: 'Demandes', icon: ClipboardList },
  { id: 'notifications', label: 'Notifs', icon: Bell },
  { id: 'parametres', label: 'Paramètres', icon: Settings },
];

/** GRH tab: sub-menu grouping expenses, leave requests, agency notifications and settings. */
export function EaserGrh({ sub, onSub, onUnauthorized, notifications, unread, onNotificationRead, onGoHome }) {
  const current = GRH_SUBTABS.some((t) => t.id === sub) ? sub : 'frais';
  return (
    <div className="space-y-4" data-testid="easer-grh">
      <div className="grid grid-cols-5 gap-1 rounded-xl border border-border bg-card p-1" role="tablist" aria-label="Rubriques GRH">
        {GRH_SUBTABS.map((t) => {
          const active = current === t.id;
          return (
            <button key={t.id} type="button" role="tab" aria-selected={active} onClick={() => onSub(t.id)} data-testid={`grh-sub-${t.id}`}
              className={`relative flex flex-col items-center justify-center gap-1 min-h-[56px] rounded-lg px-0.5 text-[10px] font-semibold leading-tight text-center transition-colors ${active ? 'bg-[hsl(var(--primary))] text-white' : 'text-muted-foreground hover:text-foreground hover:bg-secondary'}`}>
              <span className="relative">
                <t.icon className="h-5 w-5" />
                {t.id === 'notifications' && unread > 0 && (
                  <span className={`absolute -top-1.5 -right-2.5 min-w-[16px] h-4 px-1 rounded-full text-[10px] font-bold leading-4 text-center ring-2 ${active ? 'bg-white text-[hsl(var(--primary))] ring-[hsl(var(--primary))]' : 'bg-destructive text-white ring-card'}`} data-testid="grh-sub-notifications-badge">{unread > 9 ? '9+' : unread}</span>
                )}
              </span>
              {t.label}
            </button>
          );
        })}
      </div>
      {current === 'frais' && <EaserExpenses onUnauthorized={onUnauthorized} />}
      {current === 'conges' && <EaserLeaves onUnauthorized={onUnauthorized} />}
      {current === 'demandes' && <EaserRequests onUnauthorized={onUnauthorized} />}
      {current === 'notifications' && <EaserNotifications items={notifications} onUnauthorized={onUnauthorized} onRead={onNotificationRead} />}
      {current === 'parametres' && <EaserSettings onGoHome={onGoHome} />}
    </div>
  );
}
